<div nz-row nzAlign="middle">
    <div (click)="navigate()" class="base-page addCursor">{{basePage}}</div>
    <div class="m-l-11">
        <svg fill="none" height="10" viewBox="0 0 6 10" width="6" xmlns="http://www.w3.org/2000/svg">
            <g opacity="0.5">
                <path d="M0.213943 1.18939C-0.0683039 0.93083 -0.0683039 0.482652 0.196303 0.206851C0.337426 0.0689502 0.53147 4.78074e-07 0.707874 4.62652e-07C0.884278 4.47231e-07 1.06068 0.0689501 1.20181 0.189613L5.78831 4.49901C5.92944 4.63691 6 4.80928 6 4.9989C6 5.18851 5.92944 5.36089 5.78831 5.49879L1.20181 9.80818C0.91956 10.0667 0.47855 10.0667 0.196303 9.79094C-0.0683032 9.51514 -0.0683032 9.0842 0.213943 8.8084L4.27124 4.9989L0.213943 1.18939Z"
                      fill="#828282"/>
                <path d="M0.213943 1.18939C-0.0683039 0.93083 -0.0683039 0.482652 0.196303 0.206851C0.337426 0.0689502 0.53147 4.78074e-07 0.707874 4.62652e-07C0.884278 4.47231e-07 1.06068 0.0689501 1.20181 0.189613L5.78831 4.49901C5.92944 4.63691 6 4.80928 6 4.9989C6 5.18851 5.92944 5.36089 5.78831 5.49879L1.20181 9.80818C0.91956 10.0667 0.47855 10.0667 0.196303 9.79094C-0.0683032 9.51514 -0.0683032 9.0842 0.213943 8.8084L4.27124 4.9989L0.213943 1.18939Z"
                      stroke="#828282"/>
            </g>
        </svg>
    </div>
    <div class="current-page m-l-11" style="position:relative;top:.5px">
        {{currentPage}}
    </div>
</div>
